import { render, staticRenderFns } from "./departmentTreeDialog.vue?vue&type=template&id=2fef7880&scoped=true"
import script from "./departmentTreeDialog.vue?vue&type=script&lang=js"
export * from "./departmentTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./departmentTreeDialog.vue?vue&type=style&index=0&id=2fef7880&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef7880",
  null
  
)

export default component.exports